import { connect } from 'react-redux';
import SettingsAccount from './SettingsAccount';
import { openUpdateProfileModal, closeUpdateProfileModal, updateUserProfile } from '../../../actions/user';

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = dispatch => ({
  openUpdateProfileModal: () => dispatch(openUpdateProfileModal()),
  closeUpdateProfileModal: () => dispatch(closeUpdateProfileModal()),
  updateUserProfile: (id, data) => dispatch(updateUserProfile(data)),
});

const SettingsAccountContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsAccount);

export default SettingsAccountContainer;



// WEBPACK FOOTER //
// ./src/components/Settings/user/SettingsAccountContainer.js